import { gql } from '../../__generated__'

export const GET_NOTIFICATIONS = gql(/* GraphQL */ `
  query GetNotifications($orderBy: [NotificationOrderByInput!]!) {
    notifications(orderBy: $orderBy) {
      id
      type
      content
      timeRead
      createdAt
    }
  }
`)

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql(/* GraphQL */ `
  query GetUnreadNotificationsCount {
    notificationsCount(where: { timeRead: null })
  }
`)

export const UPDATE_NOTIFICATION = gql(/* GraphQL */ `
  mutation UpdateNotification(
    $where: NotificationWhereUniqueInput!
    $data: NotificationUpdateInput!
  ) {
    updateNotification(where: $where, data: $data) {
      id
      timeRead
    }
  }
`)
